import {createActions, createAction, handleAction,handleActions, combineActions} from 'redux-actions'
import * as Actions from './actions';
import log from 'components/utils/Logger';

const defaultState = ({
    payload:{
    },
    meta: {
        fetch: false,
        status: ""
    }
});


const defaultReducerMap = {
    next: (state, action) => {
        return {...action}
    },
    throw: (state, action) => {
        return (Object.assign(action, {
            meta: {
                fetch: false,
                status: Actions.statusEnum.FAILURE
            }
        }))
    }
};


export const mapStatusConnection = handleAction(
    combineActions(
        Actions.http.connection.mapStatus.get,
    ), defaultReducerMap, defaultState);



const defaultArray = ({
    payload: []
});
const defaultObject = ({
    payload: {
    }
});
const defaultBool = ({
    payload: false
});

export const mapStatus = handleAction(Actions.data.mapStatus,
    (state, action) => {
        return action
    },
    defaultObject
);
export const mapLabels = handleAction(Actions.data.mapLabels,
    (state, action) => {
        return action
    },
    defaultObject
);
export const stockStatus = handleAction(Actions.data.stockStatus,
    (state, action) => {
        return action
    },
    defaultObject
);



const defaultFailureObject = ({
    payload: {
        code: 4824,
        is_succeed: false,
        message: "",
    },
    meta: {
        isShow: false
    }
})
export const failure = handleAction(Actions.data.failure,
    (state, action) => {
        return action
    },
    defaultFailureObject
);



const defaultSuccessObject = ({
    payload: {
        message: ""
    },
    meta: {
        isShow: false
    }
});
export const success = handleAction(Actions.data.success,
    (state, action) => {
        return action
    },
    defaultSuccessObject
);




// WEBPACK FOOTER //
// ./src/redux/reducers.js